import * as React from 'react';
import {Col, Grid, Row} from 'react-bootstrap';
import {Redirect} from 'react-router-dom';
import {isAuthenticated} from './App';

import ReactLoading from 'react-loading';
import {raw} from 'body-parser';

export class Login extends React.Component {
	public state: any;

	constructor(props) {
		super(props);
		this.state = {
			user: localStorage.getItem('user') || '',
			pw: localStorage.getItem('pw') || '',
			loggedIn: props.loggedIn,
			redirectToReferrer: props.loggedIn
		};

		this.handleChange = this.handleChange.bind(this);
		this.handlePwChange = this.handlePwChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	public handleChange(event) {
		this.setState({user: event.target.value});
		localStorage.setItem('user', event.target.value);
	}

	public handlePwChange(event) {
		this.setState({pw: event.target.value});
		localStorage.setItem('pw', event.target.value);

	}

	public async handleSubmit(event) {
		event.preventDefault();
		await this.login();
	}

	public async login() {
		const postData = {
			password: this.state.pw,
			username: this.state.user
		};
		const rawResponse = await fetch('/api/login', {
			body: JSON.stringify(postData),
			credentials: 'include',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			method: 'POST'
		});
		const content = rawResponse;
		const text = await rawResponse.text();
		console.log(text);
		const success = rawResponse.status === 200;
		console.log(content);
		if ((content && success === false) || text === 'Unauthorized') {
			console.log('Failed to login');
			this.setState({loggedIn: false, redirectToReferrer: false}, () => {
				isAuthenticated.logged = false;
			});
			localStorage.removeItem('user');
			localStorage.removeItem('pw');
		} else if ((content && success === true) && text === 'Logged in.') {
			console.log('Logged in Successfully');
			this.setState({redirectToReferrer: true}, () => {
				isAuthenticated.logged = true;
			});
		}
	}

	public render() {
		const props: any = this.props;
		const {from} = props.location.state || {from: {pathname: '/'}};

		if (this.state.redirectToReferrer === undefined || this.state.redirectToReferrer === null) {
			this.login();
		}

		if (this.state.redirectToReferrer) {
			isAuthenticated.logged = true;
			return <Redirect to={from}/>;
		}
		return (
			<Grid>
				<Col md={6}>
					<form className="form" onSubmit={this.handleSubmit}>
						<label>
							Username:
						</label>
						<input className="form-control" name="username" type="text" value={this.state.username}
							   onChange={this.handleChange}/>
						<label>
							Password:
						</label>
						<input className="form-control" name="password" type="password" value={this.state.password}
							   onChange={this.handlePwChange}/>
						<input className="btn btn-default" type="submit" value="Submit"/>
					</form>
				</Col>
				<Col md={6} className={'center'} hidden={isAuthenticated.logged !== true}>
					<ReactLoading color={'#357EDD'} height={'25%'} width={'25%'}/>
				</Col>
			</Grid>
		);
	}

}



// WEBPACK FOOTER //
// ./src/Login.tsx